import { put, putResolve, takeLatest } from 'typed-redux-saga/macro';
import { apiEvents } from 'features/pay/constants';
import { fetchIsaAllowance, getIsaAllowance } from '../actions';
// Deposits into a pot or a trading account use up ISA allowance, so refetch it once one succeeds
const DEPOSIT_SUCCESS_ACTIONS = [
    'INTERNAL_TRANSFER_SUCCESS',
    'DEPOSIT_POT_DIRECT_DEBIT_SUCCESS',
    'TOP_UP_POT_USING_OB_CREATED',
    apiEvents.topUpSecclAccountFromBankAccountUsingDirectDebit[1],
    'TOP_UP_SECCL_ACCOUNT_USING_OB_CREATED',
];
// putResolve keeps the worker running until the request settles,
// which is how long takeLeading ignores further FETCH_ISA_ALLOWANCE actions
function* fetchIsaAllowanceWorker() {
    yield* putResolve(getIsaAllowance());
}
function* refetchIsaAllowanceWorker() {
    yield* put(fetchIsaAllowance());
}
function* wealthSaga() {
    yield* takeLatest('FETCH_ISA_ALLOWANCE', fetchIsaAllowanceWorker);
    yield* takeLatest(DEPOSIT_SUCCESS_ACTIONS, refetchIsaAllowanceWorker);
}
export default wealthSaga;
